import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/Logo_Prosperian_Blanc.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="top-banner">
        <div className="banner-content">
          <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer" className="banner-link">
            Évaluez la maturité commerciale de votre entreprise
          </a>
          <span className="separator">•</span>
          <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer" className="banner-link">
            Obtenir mon Score
          </a>
        </div>
      </div>
      <div className="main-header">
        <div className="container">
          <div className="logo-container">
            <Link to="/" className="logo">
              <img src={logo} alt="Prosperian Logo" />
            </Link>
          </div>
          
          <nav className={`navigation ${isMenuOpen ? 'show' : ''}`}>
            <ul className="nav-links">
              <li><Link to="/" onClick={toggleMenu}>Accueil</Link></li>
              <li><Link to="/methode" onClick={toggleMenu}>Méthode</Link></li>
              <li><Link to="/suite" onClick={toggleMenu}>Suite</Link></li>
              <li><Link to="/score" onClick={toggleMenu}>Score</Link></li>
              <li><Link to="/etudes-de-cas" onClick={toggleMenu}>Études de cas</Link></li>
              <li><Link to="/faq" onClick={toggleMenu}>FAQ</Link></li>
              <li><Link to="/a-propos" onClick={toggleMenu}>À propos</Link></li>
              <li><Link to="/charte" onClick={toggleMenu}>Charte</Link></li>
              <li><Link to="/client" onClick={toggleMenu}>Accès Client</Link></li>
              <li className="mobile-only">
                <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer" onClick={toggleMenu}>Nous Contacter</a>
              </li>
            </ul>
          </nav>
          
          <div className="contact-buttons desktop-only">
            <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer" className="btn-contact">Nous Contacter</a>
          </div>
          
          <button className="menu-toggle" onClick={toggleMenu} aria-label="Menu">
            <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 